module.exports = __webpack_public_path__ + "assets/f0cb5f69f92a4dbe63b6a51bfa9293b7.png";